import React from "react";

const NormalInput = ({ label, value, setterFun, isRequired, type, placeholder }) => {
  const isFile = type === "file";

  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-900">
        {label}
        {isRequired && <span className="text-red-500">*</span>}
      </label>

      <input
        type={type || "text"}
        onChange={(e) => {
          setterFun(isFile ? e.target.files[0] : e.target.value);
        }}
        // Show value ONLY when not file
        {...(!isFile && { value })}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
        placeholder={placeholder}
        required
      />
    </div>
  );
};

export default NormalInput;
